import type { EventBusPayload } from "@/modules/event-bus";

import { useQueryClient } from "@tanstack/react-query";

import { isNotificationBroadcastObservationCommentedPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { OBSERVATIONS_MODEL_KEYS } from "@/entities/observation";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";

import { notifyObservationComment } from "./observation-action-commented.helper";

export const useObservationActionCommented = () => {
  const { notify } = useAppNotification();
  const queryClient = useQueryClient();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastObservationCommentedPayload(payload)) return;
    if (isBroadcastNotificationEnabled("observation-comment")) {
      notifyObservationComment({ notify, payload });
    }
    queryClient.invalidateQueries({
      queryKey: [
        OBSERVATIONS_MODEL_KEYS.COMMENTS_LIST,
        "list",
        payload.observation.id,
      ],
    });

    invalidateNotifications("*");
  };

  return { runAction };
};
